<script>

    import { toast } from 'bulma-toast'
    import { eventStore, modalStore } from '../stores'

    import LocationsService from '../$services/locations.service'

    import Button from '../$components/button.svelte'
    import File from '../$components/file.svelte'
    import Form from '../$components/form.svelte'

    let loading = false
    let data = {}

    async function uploadLocations() {

        loading = true
        const resp = await LocationsService.uploadLocations(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        modalStore.set(null)
        eventStore.set('LocationsUpdated')
    }

</script>

<Form on:submit={uploadLocations} { loading } >

    <label for="" class="label">Archivo de direcciones</label>
    <File bind:file={ data.locationsFile } />
    <br>
    <a href="files/locations_template.csv">Descargar plantilla</a>

    <div class="items-end">
        <div class="buttons">
            <Button on:click={() => modalStore.set(null)} type="button" text="Cancelar" icon="ban" />
            <Button type="submit" text="Guardar" icon="save" color="primary" />
        </div>
    </div>
</Form>